document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.carousel').forEach(function (carousel) {
        const carouselList = carousel.querySelector('.carousel__list');
        const elems = Array.from(carousel.querySelectorAll('.carousel__item'));
        const paginationButtons = Array.from(carousel.querySelectorAll('.splides-page'));

        if (!carouselList || !elems.length) return;

        let startX = 0;
        let startY = 0;
        let endX = 0;
        let endY = 0;

        const getPos = function (current, active) {
            const diff = current - active;

            if (Math.abs(diff) > 1) {
                return -current;
            }

            return diff;
        };

        const syncPagination = function (activeItem) {
            const activeIndex = elems.indexOf(activeItem);

            paginationButtons.forEach(function (button, index) {
                const isActive = index === activeIndex;

                button.classList.toggle('is-active', isActive);
                if (isActive) {
                    button.setAttribute('aria-current', 'true');
                } else {
                    button.removeAttribute('aria-current');
                }
            });
        };

        const update = function (newActive) {
            if (!newActive) return;

            const newActivePos = Number(newActive.dataset.pos);
            const current = elems.find(function (elem) { return Number(elem.dataset.pos) === 0; });
            const prev = elems.find(function (elem) { return Number(elem.dataset.pos) === -1; });
            const next = elems.find(function (elem) { return Number(elem.dataset.pos) === 1; });

            if (!current || newActive === current) {
                syncPagination(current || newActive);
                return;
            }

            current.classList.remove('carousel__item_active');

            [current, prev, next].filter(Boolean).forEach(function (item) {
                const itemPos = Number(item.dataset.pos);
                item.dataset.pos = getPos(itemPos, newActivePos);
            });

            newActive.classList.add('carousel__item_active');
            syncPagination(newActive);
        };

        const swipeToNext = function () {
            update(elems.find(function (elem) { return Number(elem.dataset.pos) === 1; }));
        };

        const swipeToPrev = function () {
            update(elems.find(function (elem) { return Number(elem.dataset.pos) === -1; }));
        };

        const handleTouchMove = function (event) {
            const currentX = event.touches[0].clientX;
            const currentY = event.touches[0].clientY;

            if (Math.abs(currentX - startX) > Math.abs(currentY - startY)) {
                event.preventDefault();
            }
        };

        carouselList.addEventListener('touchstart', function (event) {
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            carouselList.addEventListener('touchmove', handleTouchMove, { passive: false });
        }, { passive: true });

        carouselList.addEventListener('touchend', function (event) {
            endX = event.changedTouches[0].clientX;
            endY = event.changedTouches[0].clientY;

            const horizontalDistance = startX - endX;
            const verticalDistance = startY - endY;

            if (Math.abs(horizontalDistance) > 50 && Math.abs(horizontalDistance) > Math.abs(verticalDistance)) {
                if (horizontalDistance > 0) {
                    swipeToNext();
                } else {
                    swipeToPrev();
                }
            }

            carouselList.removeEventListener('touchmove', handleTouchMove);
        });

        paginationButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                update(elems[Number(button.dataset.slideIndex)]);
            });
        });

        const initialActive = elems.find(function (elem) { return Number(elem.dataset.pos) === 0; }) || elems[0];
        initialActive.classList.add('carousel__item_active');
        syncPagination(initialActive);
    });
});
